/** スポット一覧の上に置く「◯件 / すべて選択」の行 */

import { Button } from '@/components/ui/button'

type Props = {
  count: number
  /** 一覧のうちまだ選んでいない件数。0 ならボタンを押せなくする */
  unselectedCount: number
  onSelectAll: () => void
}

export const SelectAllRow = ({ count, unselectedCount, onSelectAll }: Props) => (
  <div className="flex items-center justify-between text-xs text-muted-foreground">
    <span className="tabular-nums">{count} 件</span>
    <Button variant="ghost" size="sm" className="h-7 px-2!" disabled={unselectedCount === 0} onClick={onSelectAll}>
      すべて選択
    </Button>
  </div>
)
